import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

// Bootstrap components
import Container from "react-bootstrap/Container";

// Styles
import "../assets/scss/pages/order.scss";

// API
import { getMeApi } from "../api/user";
import { getOrder } from "../api/order";

// Hooks
import useAuth from "../hooks/useAuth";

// Utils
import formatMoney from "../utils/formatMoney";

export default function Order() {
  const { id } = useParams();
  // const [user, setUser] = useState(undefined);
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);
  const { auth, logout, user } = useAuth();
  // useEffect(() => {
  //   (async () => {
  //     const response = await getMeApi(logout);
  //     setUser(response);
  //   })();
  // }, [auth]);

  useEffect(() => {
    (async () => {
      if (user && Object.keys(user || {})?.length > 0) {
        const response = await getOrder(id, logout);
        if (response?.docs !== null && response?.docs.length > 0) {
          setOrder(response.docs[0]);
          // console.log(response);
        } else setOrder([]);
        setLoading(false);
      }
    })();
  }, [user]);
  // console.log(order);

  if (loading) {
    return (
      <section className="order__wrapper">
        <Container className="order__container text-center">
          <p className="py-4">Cargando información de orden...</p>
        </Container>
      </section>
    );
  }
  return (
    <div className="order__wrapper">
      <Container className="order__container">
        <Link to="/profile" className="text-muted">
          Regresar
        </Link>
        <h2>Orden confirmada</h2>

        {/* Order Details */}
        <div className="order-section">
          <h4>Detalles de la Orden</h4>
          <p>
            <span>Id de orden: </span>
            <span>{order?.orderId}</span>
          </p>
          <p>
            <span>Id de pago: </span>
            <span>{order?.token}</span>
          </p>
          <p>
            <span>Fecha de creación: </span>
            <span>{new Date(order?.createdAt).toLocaleString()}</span>
          </p>
        </div>

        {/* Shipping Information */}
        <div className="order-section">
          <h4>Información de Envío</h4>
          <p>
            <span>Método de envío: </span>
            <span>
              {order?.shipping?.method === 'premium' && 'Envío Gratuito Premium'}
              {order?.shipping?.method === 'express' && 'Envío Express'}
              {order?.shipping?.method === 'overnight' && 'Entrega al Día Siguiente'}
            </span>
          </p>
          <p>
            <span>Número de rastreo: </span>
            <span className={!order?.shipping?.trackingNumber ? "pending-info" : ""}>
              {order?.shipping?.trackingNumber || "La información se reflejará pronto"}
            </span>
          </p>
          <p>
            <span>Transportista: </span>
            <span className={!order?.shipping?.carrier ? "pending-info" : ""}>
              {order?.shipping?.carrier ? order.shipping.carrier.toUpperCase() : "La información se reflejará pronto"}
            </span>
          </p>
          <p>
            <span>Entrega estimada: </span>
            <span className={!order?.shipping?.estimatedDelivery ? "pending-info" : ""}>
              {order?.shipping?.estimatedDelivery
                ? new Date(order.shipping.estimatedDelivery).toLocaleDateString('es-MX', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })
                : "La información se reflejará pronto"}
            </span>
          </p>
          <p>
            <span>Enviado el: </span>
            <span className={!order?.shipping?.shippedAt ? "pending-info" : ""}>
              {order?.shipping?.shippedAt
                ? new Date(order.shipping.shippedAt).toLocaleDateString('es-MX', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })
                : "La información se reflejará pronto"}
            </span>
          </p>
          <p>
            <span>Entregado el: </span>
            <span className={!order?.shipping?.deliveredAt ? "pending-info" : ""}>
              {order?.shipping?.deliveredAt
                ? new Date(order.shipping.deliveredAt).toLocaleDateString('es-MX', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })
                : "La información se reflejará pronto"}
            </span>
          </p>
          <p>
            <span>Instrucciones especiales: </span>
            <span className={!order?.shipping?.specialInstructions ? "pending-info" : ""}>
              {order?.shipping?.specialInstructions || "La información se reflejará pronto"}
            </span>
          </p>
        </div>

        {/* Customer Information */}
        <div className="order-section">
          <h4>Información del Cliente</h4>
          <p>
            <span>Nombre: </span>
            <span>{order?.clientName}</span>
          </p>
          <p>
            <span>Email: </span>
            <span>{order?.clientEmail}</span>
          </p>
          <p>
            <span>Teléfono: </span>
            <span>{order?.clientPhoneNumber}</span>
          </p>
        </div>

        {/* Shipping Address */}
        <div className="order-section">
          <h4>Dirección de Envío</h4>
          <p>
            <span>Dirección: </span>
            <span>{order?.address}</span>
          </p>
          <p>
            <span>Número: </span>
            <span>{order?.streetNumber}</span>
          </p>
          <p>
            <span>Colonia: </span>
            <span>{order?.neighborhood}</span>
          </p>
          <p>
            <span>Código Postal: </span>
            <span>{order?.postalCode}</span>
          </p>
          <p>
            <span>Referencia: </span>
            <span>{order?.reference}</span>
          </p>
          <p>
            <span>Municipio: </span>
            <span>{order?.municipality}</span>
          </p>
          <p>
            <span>Ciudad: </span>
            <span>{order?.city}</span>
          </p>
          <p>
            <span>Estado: </span>
            <span>{order?.state}</span>
          </p>
          <p>
            <span>País: </span>
            <span>{order?.country}</span>
          </p>
        </div>

        {/* Payment Information */}
        <div className="order-section">
          <h4>Información de Pago</h4>
          {order?.installments_enabled ? (
            <>
              <p>
                <span>Meses sin intereses: </span>
                <span>{order.installments_meses}</span>
              </p>
              <p>
                <span>Pago mensual: </span>
                <span>{formatMoney(order.installments_pago_mensual)} MXN</span>
              </p>
            </>
          ) : (
            <p>
              <span>Pago único</span>
            </p>
          )}
          <p>
            <span>Total: </span>
            <span>{formatMoney(order?.total)} MXN</span>
          </p>
        </div>

        {/* Order Items */}
        <div className="order-section">
          <h4>Productos ({order?.orderItems.length})</h4>
          {order?.orderItems.map((item) => (
            <div className="order-item" key={item.product.id}>
              <p>
                <span>Producto: </span>
                <span>{item.product.nombre}</span>
              </p>
              <p>
                <span>Precio: </span>
                <span>{formatMoney(item.product.precio)} MXN</span>
              </p>
              <p>
                <span>Cantidad: </span>
                <span>{item.quantity}</span>
              </p>
              <p>
                <span>Tiempo estimado de entrega: </span>
                <span>{item.product.eta} días</span>
              </p>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
